/* GENERATED FILE. DO NOT EDIT.
 * Source: contracts/service-area-postal-codes.json
 * Public delivery guidance; checkout enforcement status is contract-owned and must be re-read after provider changes.
 */
window.LTServiceAreaPostalCodes = Object.freeze(
{
  "checkoutEnforcementStatus": "verified_native_local_delivery_2026_08_08",
  "schemaVersion": 1,
  "serviceAreas": [
    {
      "deliveryPriceCents": 1500,
      "id": "wasatch-front",
      "label": "Wasatch Front",
      "postalCodes": [
        "84003",
        "84004",
        "84005",
        "84006",
        "84010",
        "84013",
        "84014",
        "84015",
        "84016",
        "84020",
        "84025",
        "84032",
        "84037",
        "84040",
        "84041",
        "84042",
        "84043",
        "84044",
        "84045",
        "84047",
        "84049",
        "84050",
        "84054",
        "84056",
        "84057",
        "84058",
        "84059",
        "84062",
        "84065",
        "84067",
        "84070",
        "84075",
        "84084",
        "84087",
        "84088",
        "84089",
        "84090",
        "84091",
        "84092",
        "84093",
        "84094",
        "84095",
        "84096",
        "84097",
        "84101",
        "84102",
        "84103",
        "84104",
        "84105",
        "84106",
        "84107",
        "84108",
        "84109",
        "84110",
        "84111",
        "84112",
        "84113",
        "84114",
        "84115",
        "84116",
        "84117",
        "84118",
        "84119",
        "84120",
        "84121",
        "84122",
        "84123",
        "84124",
        "84125",
        "84128",
        "84145",
        "84147",
        "84148",
        "84150",
        "84153",
        "84158",
        "84165",
        "84171",
        "84180",
        "84184",
        "84189",
        "84190",
        "84199",
        "84310",
        "84315",
        "84317",
        "84401",
        "84402",
        "84403",
        "84404",
        "84405",
        "84407",
        "84408",
        "84409",
        "84412",
        "84414",
        "84415",
        "84601",
        "84602",
        "84603",
        "84604",
        "84605",
        "84606",
        "84633",
        "84651",
        "84653",
        "84655",
        "84660",
        "84663",
        "84664"
      ]
    },
    {
      "deliveryPriceCents": 5000,
      "id": "park-city",
      "label": "Park City",
      "postalCodes": [
        "84060",
        "84068",
        "84098"
      ]
    }
  ]
}
);
